// removed by extract-text-webpack-plugin
module.exports = {"content":"content___13wW7"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/PageHeaderLayout.less
// module id = jeyO
// module chunks = 15 16 17 20 21 28 41 42 43 44 45 46 47 48